import React, { CSSProperties } from 'react';

import { t } from 'i18next';

import { useGetLatestActivitiesQuery } from '@school_ify/schoolify-repository/src/shared/types';

import Card from 'components/Card/Card';
import useDeviceDetect from 'hooks/useDeviceDetect';
import listIcon from 'assets/icons/header/latest-activites.svg';

import ActivityItem from '../LatestStudentActivity/components/ActivityItem/ActivityItem';

import './LatestActivity.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
}

const Classes: React.FC<Props> = ({ style }) => {
  const { isMobile } = useDeviceDetect();
  const { data } = useGetLatestActivitiesQuery();

  return (
    <div className="latest-activity-container" style={style}>
      <Card
        title={
          <>
            <img className="card-icon" src={listIcon} alt="bell icon" />
            {t('common:latest_activity')}
          </>
        }
        foldable={isMobile}
      >
        {!isMobile && (
          <Card.Header>
            <img className="card-icon" src={listIcon} alt="bell icon" />
            <h4 className="card-title">{t('common:latest_activity')}</h4>
            <div className="filler" />
          </Card.Header>
        )}
        <Card.Body>
          {data?.latest_activities.map(activity => {
            const { id, message, created_at, path } = activity;
            const parsedMessage = JSON.parse(message);
            return (
              <ActivityItem
                key={id}
                title={t(parsedMessage.message, parsedMessage.variables)}
                date={created_at}
                path={path}
              />
            );
          })}
        </Card.Body>
      </Card>
    </div>
  );
};

export default Classes;
